const getNumDiasMes = (mesDias, agnoDias) => {
  /*
    Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
    Los meses 4,6,9,11 siempre tienen 30 días
    El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return (31);
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return (30);
  else if( mes === 2 )
  {
    if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
      return (29)
    else
      return (28)
  }   
}

export default getNumDiasMes
